import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './FormRow.scss';

const styles = {
  labelStyle: { margin: '6px 0' },
  labelParentStyle: { textAlign: 'center' },
  rootStyle: { margin: '10px 0' }
};

const FormRow = props =>
  <div className="row" style={styles.rootStyle}>
    <div className="col-sm-6" style={styles.labelParentStyle}>
      <label style={styles.labelStyle} htmlFor={props.name}>{props.label}</label>
    </div>
    <div className="col-sm-6">
      {props.type ?
        props.type === 'textarea' ?
          <textarea className="form-control" name={props.name} rows={4} onChange={props.onChange}/>
        : Object.keys(props).indexOf('value') >= 0 ? <input disabled={props.disabled} type={props.type} className="form-control" checked={props.value} value={props.value ? props.value : ''} name={props.name} onChange={props.onChange} /> : <input type={props.type} className="form-control" name={props.name} onChange={props.onChange} />
        : Object.keys(props).indexOf('value') >= 0 ? <input disabled={props.disabled} type="text" className="form-control" value={props.value ? props.value : ''} name={props.name} onChange={props.onChange} /> :
        <input type="text" className="form-control" checked name={props.name} onChange={props.onChange} />
      }
    </div>
  </div>;

export default withStyles(s)(FormRow);



// WEBPACK FOOTER //
// src/components/FormRow/FormRow.js